import React from 'react';
import './App.css';
import Layout from './HOC/Layout/Layout';

function App() {
  return (
    <div className="App">
      <Layout />
    </div>
  );
}

export default App;
